import { axios } from '@/http/api'
import common from '@/http/response'
const URL = '/configuration'

export default {
  getDispatchConfiguration (baseUrl) {
    return axios.get(baseUrl + URL +'/list' ).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  }
}
